import { InjectionToken } from '@angular/core';

export const ENVIRONMENT = new InjectionToken<any>('environment');
export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const DEFAULT_TIMEOUT_MILLISECOND = 60000;
